<template>
  <div v-if="displayVue" class="tracking-order">
    <div v-if="readOnlyThales()">
      <h1 class="font-weight-bold">Suivi des expéditions - Thales LAS France OME Elancourt</h1>
    </div>
    <div class="title">
      <h2>Suivi de document</h2>
    </div>
    <b-input-group class="mt-3" size="lg">
      <b-form-input
        placeholder="Référence LS : 87654321 ou Référence GEX : 54321"
        v-model="documentCode"
        :state="documentIdIsValid"
        @keyup.native.enter="searchDocument()"
      >
      </b-form-input>
      <b-input-group-append>
        <b-button
          class="search-btn"
          @click="searchDocument()"
          :disabled="!documentIdIsValid"
          >Rechercher</b-button
        >
      </b-input-group-append>
    </b-input-group>
    <div v-if="displayList">
      <div v-for="(document, indexDoc) in listDocuments" :key="indexDoc" >
        <div v-show="displayList" class="wrapper-flux">
          <div class="wrapper-header">
            <h5>{{ document.boucle.replace('_', ' ').toUpperCase() }}</h5>
            <span
              v-if="!readOnlyThales()"
              @click="
                !document.isBlocked
                  ? blockDocument(indexDoc)
                  : unblockDocument(indexDoc)
              "
              class="clickable right-item"
            >
              <i class="fa fa-pause-circle" aria-hidden="true"></i>
              {{
                !document.isBlocked
                  ? 'Bloquer le document'
                  : 'Débloquer le document'
              }}
            </span>
            <span
              v-if="!readOnlyThales()"
              @click="stopDocumentModal(indexDoc)"
              :class="
                document.documentStopped ? 'right-item' : 'clickable right-item'
              "
            >
              <i
                v-if="!document.documentStopped"
                class="fa fa-times-circle"
                aria-hidden="true"
              ></i>
              {{
                document.documentStopped ? 'Document clos' : 'Clore ce document'
              }}
            </span>
          </div>
          <div class="document-tracking">
            <div class="tracking-document-header">
              <div class="document-number">
                Colis numéro :
                <b> &nbsp; {{ chunk(document.code, 3) }}</b>
                <div v-if="document.sdcd" class="sdcd-pill"></div>
              </div>
            </div>
            <div
              v-if="!document.isBlocked"
              class="row mx-auto justify-content-center"
            >
              <div
                v-for="(value, name, index) in document.stations"
                :key="index"
                class="col-12 col-sm-10 col-md document-station"
                :class="{
                  'opacity-1': value.leadtime,
                  'redbin-station': name === 'Red bin'
                }"
              >
                <div v-if="name === 'Red bin'" class="icon-station">
                  <img
                    src="../../assets/exclamation-icon.svg"
                    alt="Icon danger"
                  />
                </div>
                <div v-else class="icon-station">
                  <img
                    :src="require('../../assets/' + setIcon(name))"
                    alt="Icon station"
                  />
                </div>
                <div>
                  <span v-if="value.leadtime">{{
                    value.leadtime | moment('DD/MM/YYYY HH:mm')
                  }}</span>
                  <span v-else> Non scanné</span>
                </div>
                <h5 class="station-name">
                  {{ name === 'Red bin' ? 'Retard de traitement' : name }}
                </h5>
                <div
                  v-if="name === 'Red bin'"
                  class="icon-check"
                  style="--icon-color: var(--danger)"
                >
                  <i class="fa fa-times-circle"></i>
                </div>
                <div
                  v-else
                  class="icon-check"
                  :style="{ '--icon-color': colorValue(value) }"
                >
                  <i class="fa fa-check-circle"></i>
                </div>
                <!-- <div
                  v-if="comment"
                  class="comment comment-display"
                >
                  {{value.comment}}
                </div>
                <div
                  v-else-if="!comment && !readOnlyThales()"
                  class="comment comment-add"
                >
                  Ajouter un commentaire
                </div> -->
              </div>
            </div>
            <div v-else class="row mx-auto justify-content-center">
              <div class="col-12 col-sm-10 col-md document-station">
                <div class="icon-station">
                  <img
                    src="../../assets/exclamation-icon.svg"
                    alt="Icon danger"
                  />
                </div>
                <h5 class="station-name">Document bloqué</h5>
                <div class="icon-check" style="--icon-color: var(--danger)">
                  <i class="fa fa-times-circle"></i>
                </div>
              </div>
            </div>
            <div class="row mx-auto justify-content-center">
              <b-button
                variant="outline-secondary"
                @click="updateComment(indexDoc)"
                v-if="!readOnlyThales()"
              >
                <i class="fa fa-plus" aria-hidden="true"></i>
                Ajouter un commentaire
              </b-button>
              <transition name="list">
                <div v-if="document.addingComment" class="comment comment-add">
                  <b-form-textarea
                    class="form-control"
                    aria-label="With textarea"
                    placeholder="Commentaire..."
                    v-model="newComment"
                    rows="3"
                    max-rows="3"
                    no-auto-shrink
                    :state="
                      !isEmpty(newComment) &&
                      newComment.length >= 2 &&
                      newComment.length < 256
                    "
                  >
                  </b-form-textarea>
                  <b-button variant="outline-secondary" @click="cancelComment(indexDoc)">
                    <i class="fa fa-close" aria-hidden="true"></i>
                    Annuler
                  </b-button>
                  <b-button
                    style="margin-left: 2%"
                    variant="outline-success"
                    @click="sendComment(indexDoc)"
                    :disabled="
                      isEmpty(newComment) ||
                      newComment.length < 2 ||
                      newComment.length > 256
                    "
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Enregistrer
                  </b-button>
                </div>
              </transition>
              <transition-group class="comment-transition" name="list" tag="p">
                <div
                  v-for="row in comments[document.code]"
                  :key="row.uniqid"
                  class="comment comment-display transition-comment-item"
                  style="width: 99%"
                >
                  {{ row.comment }}
                  <i
                    class="fa fa-times-circle comment-close clickable"
                    aria-hidden="true"
                    @click="deleteComment(row.uniqid, indexDoc)"
                  ></i>
                  <div class="comment-date">
                    {{ row.created_at | moment('[Le] DD/MM/YYYY [à] HH:mm') }}
                  </div>
                </div>
              </transition-group>
            </div>
          </div>
        </div>
        <StopDocumentModal
          v-if="document.code"
          :ref="document.code"
          :code="document.code"
          :title="getTitle(document.code)"
          @reset-form="clearLastInfo"
        />
      </div>
    </div>
    <div v-if="readOnlyThales()" class="wrapper-footer">
      <p>Vos standards d'expéditions et d'activités ici: <a href="https://wiki.corp.thales/pages/viewpage.action?pageId=1085543033">Expédition / ADV Logistique - LAS - Thales LAS
        Elancourt - Site global (corp.thales)</a></p>
      <div class="thalesLogo">
        <img alt="thales-logo" src="../../assets/img/thales-logo.png"/>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import server from '../../api/server.vue'
import StopDocumentModal from './StopDocumentModal.vue'

export default {
  name: 'Tracking',
  components: { StopDocumentModal },
  data() {
    return {
      listDocuments: {},
      comments: {},
      documentCode: '',
      documentIdIsValid: false,
      newComment: '',
      savedComment: '',
      documentData: {
        code: '',
        comment: '',
        boucle: '',
        stations: {}
      },
      docDescription: '',
      docXtype: '',
      found: false,
      documentStopped: false,
      isBlocked: false,
      displayList: false,
      displayVue: true
    }
  },
  watch: {
    documentCode: function (val) {
      var re = new RegExp('^.{8}$')
      if ( val.length == 6 || val.length == 5 || val.length == 4 || val.includes("GEX")) {
        re = new RegExp('^GEX[0-9]{4,6}$|^[0-9]{4,6}$')
      }
      this.documentIdIsValid = re.test(val)
    }
  },
  computed: {},
  methods: {
    sendComment(indexKey) {
      server.sendDocumentComment(this.listDocuments[indexKey].code, this.newComment).then(result => {
        this.$toasted.success('Commentaire rajouté')

        this.comments[this.listDocuments[indexKey].code].push(result.data)
        this.listDocuments[indexKey].addingComment = false
        this.newComment = ''
      })
    },
    deleteComment(uniqid, indexKey) {
      server.deleteComment(uniqid).then(result => {
        this.$toasted.success('Commentaire supprimé !')
        server.getDocumentComment(this.listDocuments[indexKey].code).then(result => {
          this.comments[this.listDocuments[indexKey].code] = result.data
          this.update()
        })
      })
    },
    updateComment(indexKey) {
      // this.savedComment = comment
      // Vue.set(this.documentData, 'comment', false)
      this.listDocuments[indexKey].addingComment = !this.listDocuments[indexKey].addingComment
      this.update()
    },
    cancelComment(indexKey) {
      // if (this.savedComment) {
      //   Vue.set(this.documentData, 'comment', this.savedComment)
      // }
      this.newComment = ''
      this.listDocuments[indexKey].addingComment = false
      this.update()
    },
    getTitle(documentCode) {
      if (documentCode) {
        return 'Clôturer le document ' + documentCode
      }
    },
    stopDocumentModal(indexKey) {
      if (!this.listDocuments[indexKey].documentStopped) {
        /* console.log(this.$refs) */
        this.$refs[this.listDocuments[indexKey].code][0].showModal()
      }
    },
    setIcon(name) {
      if (name === 'Emballage') {
        return 'icon-colis.svg'
      } else if (name === 'Matériel expédié') {
        return 'icon-camion.svg'
      } else {
        return 'icon-time.svg'
      }
    },
    searchDocument() {
      /* if(documentCode.includes("GEX")){
        this.goTo('/tracking_order_gex/' + this.documentCode)
      }
      else{ */
      this.goTo('/tracking_order/' + this.documentCode)
      //}
    },
    isDocumentInRedbin(scanList) {
      return scanList[scanList.length - 1].workstation.position === 0
    },
    getDocumentTracking(documentCode, indexKey) {
      this.displayList = true
      this.clearLastInfo()
      server
        .getDocumentComment(documentCode)
        .then(result => {
          this.comments[documentCode] = result.data
          server
            .getDocumentTracking(documentCode)
            .then(result => {
              this.found = true
              this.listDocuments[indexKey] = {
                code: '',
                comment: '',
                boucle: '',
                stations: {},
                docDescription: '',
                docXtype: '',
                found: true,
                sdcd: false,
                documentStopped: false,
                addingComment: false
              }
              this.listDocuments[indexKey].code = result.data['code']
              this.listDocuments[indexKey].sdcd = result.data['sdcd']
              this.listDocuments[indexKey].comment = result.data['comment']
              this.listDocuments[indexKey].docDescription = result.data.description
              this.listDocuments[indexKey].docXtype = result.data.xtype
              this.listDocuments[indexKey].documentStopped = result.data
                .stopped_at
                ? true
                : false
              var lastScansList = result.data.scans
              var loopAssociated = lastScansList[0].workstation.loop_obj.name
              this.listDocuments[indexKey].isBlocked = result.data['blocked']
              const isInRedbin = this.isDocumentInRedbin(lastScansList)
              let positionBeforeRedbin = null
              if (isInRedbin && lastScansList.length > 1) {
                positionBeforeRedbin = lastScansList[lastScansList.length - 2].workstation.position
              }
              server.getListOfWorkstationsFromLoop(loopAssociated).then(res => {
                var stationList = res.data.splice(1, res.data.length)
                this.listDocuments[indexKey].boucle = loopAssociated
                //documentDataTemp.boucle = loopAssociated
                let workstationsObj = {}
                for (var i = 0; i < stationList.length; i++) {
                  if (i === stationList.length) {
                    workstationsObj[stationList[i].name] = {
                      leadtime: null,
                      andon: false,
                      position: stationList[i].position
                    }
                  } else {
                    workstationsObj[stationList[i].name] = {
                      leadtime: null,
                      andon: false,
                      position: stationList[i].position
                    }
                  }
                }

                for (var i = 0; i < lastScansList.length; i++) {
                  var workstation = lastScansList[i].workstation.name
                  var andon = false
                  if (i + 1 < lastScansList.length) {
                    if (
                      !lastScansList[i].scan_date &&
                      lastScansList[i + 1].scan_date
                    ) {
                      andon = true
                    }
                  }
                  if (workstation in workstationsObj) {
                    workstationsObj[workstation]['leadtime'] =
                      lastScansList[i].scan_date
                    workstationsObj[workstation]['comment'] =
                      lastScansList[i].comment
                    if (andon) {
                      workstationsObj[workstation]['andon'] = andon
                    }
                  }
                }
                if (isInRedbin) {
                  let workstationsArray = Object.entries(workstationsObj)
                  const leadTime =
                    lastScansList[lastScansList.length - 1].scan_date
                  workstationsArray.splice(positionBeforeRedbin, 0, [
                    'Red bin',
                    { leadtime: leadTime }
                  ])
                  this.listDocuments[indexKey].stations = Object.fromEntries(workstationsArray)
                  /*(documentDataTemp.stations =
                      Object.fromEntries(workstationsArray))*/
                } else {
                  this.listDocuments[indexKey].stations = workstationsObj
                  //documentDataTemp.stations = workstationsObj
                }
                this.update()
              })
              this.update()
            })
            .catch(err => {
              console.log(err)
              this.documentIdIsValid = false
              this.$toasted.error('Document non trouvé. Vérifier la référence')
            })
            this.update()
        })
        .catch(err => {
          console.log(err)
          this.documentIdIsValid = false
          this.$toasted.error('Document non trouvé. Vérifier la référence')
        })
    },
    colorValue(value) {
      if (value.leadtime) {
        return 'var(--a-dark-blue)'
      } else if (value.andon) {
        return '#dc3545'
      }
      return '#e5e5e5'
    },
    clearLastInfo() {
      this.listDocuments = {}
    },
    blockDocument(indexKey) {
      server
        .blockDocument(this.listDocuments[indexKey].code)
        .then(() => {
          this.listDocuments[indexKey].isBlocked = true
          this.update()
        })
        .catch(er => {
          console.log(er)
          this.$toasted.error('Oups! Une erreur est survenue')
        })

    },
    unblockDocument(indexKey) {
      server
        .unblockDocument(this.listDocuments[indexKey].code)
        .then(() => {
          // this.isBlocked = false
          var i = 0
          if(this.documentCode.length == 6 || this.documentCode.length == 5 || this.documentCode.length == 4 || this.documentCode.includes("GEX")){
            this.listDocumentsByGex(this.documentCode)
          }
          else{
            this.getDocumentTracking(this.listDocuments[indexKey].code, 0)
          }
          this.update()
        })
        .catch(er => {
          console.log(er)
          this.$toasted.error('Oups! Une erreur est survenue')
        })
    },
    isEmpty(value) {
      return _.isEmpty(value)
    },
    listDocumentsByGex(documentCodeGex) {
      var reverse = {}
      var code = documentCodeGex
      if(!documentCodeGex.includes("GEX")){
        code = "GEX"+documentCodeGex
      }
      server
        .getDocumentByGex(code)
        .then(document => {
          var documentList = document.data.length
          for (var i = 0; i < documentList; i++) {
            this.getDocumentTracking(document.data[i].code, i)
          }
          this.update()
        })
        .catch(er => {
          console.log(er)
          this.$toasted.error('Oups! Une erreur est survenue')
        })
    },
    update() {
      this.displayVue = false
      this.$nextTick().then(() => {
        this.displayVue = true
      })
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.document_id) {
      this.documentCode = to.params.document_id
      if (this.documentCode.length == 6 || this.documentCode.length == 5 || this.documentCode.length == 4 || this.documentCode.includes("GEX")) {
        this.listDocumentsByGex(this.documentCode)
      } else {
        this.getDocumentTracking(this.documentCode, 0)
      }
    }
    next()
  },
  mounted() {
    if (this.$route.params.document_id) {
      this.documentCode = this.$route.params.document_id
      if (this.documentCode.length == 5 || this.documentCode.length == 4) {
        this.listDocumentsByGex(this.documentCode)
      } else {
        this.getDocumentTracking(this.documentCode, 0)
      }
    }
  }
}
</script>

<style>
.tracking-order {
  width: 90%;
  margin: 3% auto;
  --dark-blue: #3174ad;
  font-family: 'Montserrat';
}

.tracking-order .title {
  text-align: left;
  margin-top: 6%;
  margin-bottom: 3%;
}

.search-btn {
  background-color: #242424;
}
#btn-add-comment {
  width: 100%;
  background-color: #95959c;
  margin: 1%;
}
.comment-date {
  position: absolute;
  right: 5px;
  color: grey;
  font-size: 0.75rem;
  top: 5px;
}

.comment-close {
  position: absolute;
  right: -7px;
  color: var(--danger);
  font-size: 1.1rem;
  top: -7px;
}
.comment {
  position: relative;
  background-color: #e5e5e5;
  font-size: 1rem;
  border-radius: 3px;
  padding: 2.5%;
  border: 2px solide white;
  min-height: 60px;
  width: 100%;
  margin: 1%;
  text-align: center;
}
.comment-display::before {
  position: absolute;
  top: -10px;
  left: 10px;
  content: '\f086';
  font-family: 'FontAwesome';
  font-size: 3.4rem;
  color: white;
}
.comment-add {
  transition: all 0.5s;
  cursor: pointer;
  font-size: 2rem;
}
.xx_comment-add::before {
  position: absolute;
  top: -6px;
  left: 10px;
  content: '\f067';
  font-family: 'FontAwesome';
  font-size: 3rem;
  color: white;
}
.comment-add:hover {
  background-color: #d5d5d5;
}
.wrapper-flux {
  margin-top: 5%;
  text-align: left;
  background-color: #e5e5e5;
  padding: 0 2rem 2rem 2rem;
  font-size: 0.7rem;
  border-radius: 3px;
}

.wrapper-header {
  padding: 1rem;
}

.wrapper-header > h5 {
  display: inline;
}

.wrapper-header > .right-item {
  font-size: 1.3em;
  float: right;
  color: var(--a-dark-blue);
  font-weight: bold;
  margin-right: 1rem;
}
.wrapper-header > .clickable.right-item:hover {
  color: #49aff7;
}

.tracking-document-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.tracking-document-header button {
  background-color: var(--a-dark-blue);
  border-color: var(--a-dark-blue);
  margin-right: 1rem;
}

.tracking-document-header button:not(.disabled):hover,
.tracking-document-header button:not(.disabled):active {
  background-color: #245c84;
  border-color: #245c84;
}

.document-tracking {
  background-color: #ffffff;
  border-radius: 3px;
}

.document-number {
  font-size: 1.5em;
  padding: 1rem 1rem 0;
  display: flex;
}

.document-station {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 1.5rem 0rem 1.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
  opacity: 0.6;
}

.document-station.opacity-1 {
  opacity: 1;
}

.document-station.redbin-station {
  background-color: #fc91912e;
  border-radius: 10px;
}

.document-station .icon-station {
  margin: 1em auto;
  height: 5em;
}

.document-station .icon-station > img {
  height: 100%;
}

.document-station .station-name {
  flex-grow: 1;
}

.document-station .icon-check {
  font-size: 2.5rem;
  text-align: center;
  color: var(--icon-color);
}

.comment-transition {
  width: 100%;
  margin-right: 1rem;
}

.transition-comment-item {
  transition: all 0.5s;
}

.list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.list-enter {
  opacity: 0;
  transform: translateY(-30px);
}

.sdcd-pill {
  background-color: #a1dfa1 !important;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  margin-left: 1rem;
  margin-top: 0.3rem;
}

.wrapper-footer {
  margin-top: 5em;
  display: flex;
  flex-direction: column;
}

.wrapper-footer > p {
  font-size: 1.5rem;
}

.thalesLogo {
  margin-top: 5em;
  width: 100%;
}

.thalesLogo img {
  width: 25.5em;
  float: center;
}

a {
  color: var(--a-dark-blue);
  text-decoration: underline;
}

@media screen and (max-width: 1024px) {
  .wrapper-footer > p {
    font-size: 1rem;
  }
}

@media screen and (max-width: 1700px) {
  .thalesLogo img {
    float: none;
  }
}

@media screen and (max-width: 768px) {
  .thalesLogo img {
    width: 15em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/document/Tracking.vue